import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import isNewMaterial from './is-new-material';
import { isFreeMaterial } from './material-helper';

const getLabel = (item: Material) => {
    let label = '';
    const itemTitle = item.title || '';

    const checkIsUkraine =
        world !== AVAILABLE_WORLDS.DE &&
        (itemTitle?.toLocaleLowerCase()?.indexOf('ukrain') >= 0 ||
            itemTitle?.toLocaleLowerCase()?.indexOf('ucrania') >= 0);

    if (checkIsUkraine && !isFreeMaterial(item)) {
        label = 'donate';
    } else if (item.sale) {
        label = 'sale';
    } else if (Boolean(item.bestInCategories) && item.bestInCategories!.length) {
        label = 'bestseller';
    } else if (isNewMaterial(item)) {
        label = 'new';
    }

    return label;
};

export default getLabel;
